import * as React from 'react'
import { connect } from 'react-redux'
import { compose, pure } from 'recompose'

import Image from '../../atoms/Image/Image'
import ProjectInfo from '../../molecules/ProjectInfo/ProjectInfo'

import { LP_IMAGE_URL } from '../../../../commons/Const'
import { CustomSpStore } from '../../../store'
import * as styles from './Project.css'

interface ProjectProps {
  isStarted: boolean
  imageUrl: string
  title: string
}

const Project: React.FunctionComponent<ProjectProps> = ({ isStarted, imageUrl, title }) => {
  // リハーサルの場合は参加者を受け付けるようにする
  return (
    <div className={styles.container}>
      <div className={styles.lImageView}>
        <Image src={imageUrl || LP_IMAGE_URL} />
      </div>
      <div>
        <ProjectInfo title={title} isStarted={isStarted} />
      </div>
    </div>
  )
}

const mapStateToProps = (state: CustomSpStore): ProjectProps => {
  const data = state.projects
  return {
    imageUrl: data.imageUrl,
    isStarted: data.isStarted,
    title: data.title
  }
}

export default compose<ProjectProps, {}>(
  connect(mapStateToProps),
  pure
)(Project)
